import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { shortLinkFor } from '../wf/links';
import ExpandableArea from './ExpandableArea';
const directReceiptLine = (name, alias) => (`Thank you for a purchase! Get a rebate and support ${name} by becoming a member here: ` + shortLinkFor(alias, 'online'));
const OnlineReplyInstructions = (props) => {
    var _a;
    const components = (_a = props.platforms) === null || _a === void 0 ? void 0 : _a.map(p => {
        switch (p.name) {
            case 'DIRECT':
                return _jsx(DirectOnlineReplyInstructions, Object.assign({}, props, { extra: " for direct customers" }));
        }
    }).filter(p => !!p).map(p => {
        return (
        // @ts-ignore
        _jsx(ExpandableArea, { title: `Add a personal message${p.props.extra}`, children: p }));
    });
    return (_jsx(React.Fragment, { children: components }));
};
const DirectOnlineReplyInstructions = ({ name, alias, oneLiner }) => {
    return (_jsxs("article", { className: "prose max-w-none mt-4 pt-4 border-t-2 mb-2", children: [_jsx("ul", { className: "list-none", children: _jsx("li", { children: "Whenever you receive a payment, send your customer a reply with this message via comment, text, or email" }) }), _jsx("code", { children: directReceiptLine(name, alias) }), _jsxs("ul", { children: [_jsx("li", { children: "This upsell link provides an automatic rebate (as credit) to customers when they sign up, based on your member discounts." }), _jsx("li", { children: "You can find the link any time by using the Copy receipt link button on your dashboard" })] })] }));
};
export default OnlineReplyInstructions;
